<form [formGroup]="form" (ngSubmit)="accept()" class="cmn-forms">
  
  <div *ngIf="details?.result?.description != undefined && details?.result?.description != ''; else loadingTermsAndConditions">
    
    <div class="termsAndConditionsContainer" [innerHTML]="details.result.description"></div>
    
    <div class="text-center cmn-modal-footer ">
      <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" class="form-check-input" />
      <label for="acceptTerms" class="alsoGrant"><p>I agree with the Term & Conditions</p> </label>
    </div>
    <div class="sendContainer">
      <button [disabled]="!form.get('acceptTerms').value" mat-raised-button type="submit">
        Next
      </button>
    </div>

  </div>

  <ng-template #loadingTermsAndConditions>
    <h1>{{ 'TermsAndConditions.Loading' | translate}}...</h1>
  </ng-template>
  
</form>
